import uuid from 'node-uuid';
import {extendObservable, computed, autorun} from 'mobx';
import storage from '../libs/storage';

class DndItemStore {
  @computed get toJson() {
    // The storage representation of the dndItems collection.
    return this.dndItems.slice();
  }
  constructor() {
    extendObservable(this, {
      dndItems: this.load()
    });

    // Create some defaults for demo purposes...
    if (!this.dndItems.length) {
      this.dndItems.push(
        {
          id: 1,
          name: 'Station Identifier'
        },
        {
          id: 2,
          name: 'Name'
        },
        {
          id: 3,
          name: 'Longitude'
        }
      );
    }

    this.persist();
  }
  find(id) {
    const dndItem = this.dndItems.find(dndItem => dndItem.id === id); // find is es7 'polyfill' provided by reactive arrays

    if (!dndItem) {
      console.warn('Failed to find dndItem: ' + id);
    }

    return dndItem;
  }
  load() {
    return storage.get('DndItemStore') || [];
  }
  persist() {
    // Whenever the Json representation of the dndItems changes, store them.
    autorun(() => {
      storage.set('DndItemStore', this.toJson);
    });
  }
}

export default new DndItemStore()




// WEBPACK FOOTER //
// ./src/stores/DndItemStore.js